import "./GeneralSettings.scss";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";

import SwipeableModals from "../SwipeableModals/SwipeableModals";
import MessageModals from "../../../components/MessageModals/MessageModals";
import ProductsSection from "./ProductsSection/ProductsSection";
import UnitsSection from "./UnitsSection/UnitsSection";

const GeneralSettings = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const [currentModalView, setCurrentModalView] = useState("changePassword");
  const [isOpen, setIsOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  return (
    <div className="views-container">
      <ProductsSection isMobile={isMobile} isTablet={isTablet} />

      <UnitsSection
        isMobile={isMobile}
        isTablet={isTablet}
        handleOpen={handleOpen}
        handleOpenDelete={handleOpenDelete}
      />

      <SwipeableModals
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        currentView={currentModalView}
      />

      <MessageModals
        open={openDelete}
        currentView="delete"
        onClose={handleCloseDelete}
      />
    </div>
  );
};

export default GeneralSettings;
